import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

const colors = {
  bg: '#f0f1f3',
  cardBg: '#ffffff',
  navy: '#071a52',
  navyLight: '#0b2981',
  greenDark: '#5cb83c',
  textPrimary: '#1a1a2e',
  textSecondary: '#6b7280',
  border: '#e2e4e8',
};

function Add() {
  const navigate = useNavigate();

  const options = [
    {
      title: 'Upload XML',
      sub: 'Import a BrickStore file to push parts to BrickLink',
      icon: '↑',
      path: '/upload',
      accent: colors.navy,
    },
    {
      title: 'Part Out',
      sub: 'Look up a set and push individual parts to your store',
      icon: '⊟',
      path: '/partout',
      accent: '#7c3aed',
    },
    {
      title: 'Quick Add',
      sub: 'Add a single part or minifig to your inventory',
      icon: '+',
      path: '/quickadd',
      accent: colors.greenDark,
    },
  ];

  // Check for active stocking session
  const hasStocking = !!localStorage.getItem('stockingParts');

  return (
    <div style={{
      minHeight: '100vh',
      background: colors.bg,
      padding: '20px',
      fontFamily: "'Outfit', sans-serif",
    }}>
      <PageHeader title="Add Inventory" icon="+" />

      {/* Stocking Mode resume banner */}
      {hasStocking && (
        <div
          onClick={() => navigate('/stocking')}
          style={{
            background: '#f0fdf4',
            border: '2px solid #bbf7d0',
            borderLeft: `4px solid ${colors.greenDark}`,
            borderRadius: '6px',
            padding: '16px 20px',
            marginBottom: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <div style={{ fontSize: '0.95rem', fontWeight: 800, color: colors.greenDark }}>
              Stocking in progress
            </div>
            <div style={{ fontSize: '0.75rem', color: colors.textSecondary, marginTop: '2px' }}>
              You have parts waiting to be shelved
            </div>
          </div>
          <div style={{
            padding: '8px 18px',
            background: colors.greenDark,
            color: '#fff',
            borderRadius: '6px',
            fontFamily: "'Outfit', sans-serif",
            fontWeight: 700,
            fontSize: '0.82rem',
          }}>
            Resume →
          </div>
        </div>
      )}

      {/* Option cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {options.map((opt, i) => (
          <div
            key={i}
            onClick={() => navigate(opt.path)}
            style={{
              background: colors.cardBg,
              border: `1px solid ${colors.border}`,
              borderLeft: `4px solid ${opt.accent}`,
              borderRadius: '6px',
              padding: '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              transition: 'transform 0.12s ease, box-shadow 0.12s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '6px',
              background: `${opt.accent}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              color: opt.accent,
              flexShrink: 0,
            }}>{opt.icon}</div>
            <div>
              <div style={{
                fontSize: '1.05rem',
                fontWeight: 800,
                color: colors.textPrimary,
                marginBottom: '3px',
              }}>{opt.title}</div>
              <div style={{
                fontSize: '0.78rem',
                color: colors.textSecondary,
                lineHeight: 1.4,
              }}>{opt.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Add;
